(() => {
  if (customElements.get('series-pill')) return;

  class SeriesPill extends HTMLElement {
    connectedCallback() {
      const configEl = this.querySelector('[data-pill-config]');
      if (!configEl) return;

      try {
        this.config = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }

      // Map variant.id -> { state, count, size }
      this.byId = {};
      (this.config.variants || []).forEach((v) => {
        this.byId[v.id] = v;
      });

      this.panel = this.querySelector('[data-pill-panel]');
      this.titleEl = this.querySelector('[data-pill-title]');
      this.subEl = this.querySelector('[data-pill-sub]');

      this._onVariantChange = this._onVariantChange.bind(this);
      document.addEventListener('variant:change', this._onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:change', this._onVariantChange);
    }

    _onVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      if (!variant) return;

      const entry = this.byId[variant.id];
      // Variante absente du mapping (ex: quick-buy d'un autre produit) -> on ignore
      if (!entry) return;

      this._render(entry);
    }

    _render(entry) {
      const states = this.config.states || {};
      const data = states[entry.state];

      // État inconnu (pas de config pour cet état) -> on masque
      if (!data) {
        this.hidden = true;
        return;
      }

      // Variante en précommande + module séries présent -> masquée (le module couvre déjà la préco)
      if (entry.state === 'preorder' && this.config.hideOnPreorder) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      if (this.panel) {
        this.panel.setAttribute('data-state', entry.state);
        // Clignotant : selon le réglage de l'état (config.pulse)
        const pulse = this.config.pulse || {};
        this.panel.classList.toggle('variant-pill__panel--pulse', !!pulse[entry.state]);
      }

      // En décompte, le serveur n'envoie le nombre exact que sous le seuil (sinon 0)
      const n = entry.count == null ? '' : entry.count;
      const size = entry.size == null ? '' : entry.size;
      const fill = (s) => (s || '').replace(/\{count\}/g, n).replace(/\{n\}/g, n).replace(/\{size\}/g, size);

      // Titre/sous-texte = inline_richtext (peuvent contenir <strong>/<em>) -> innerHTML.
      // Contenu issu des réglages du thème (marchand), pas d'entrée visiteur.
      if (this.titleEl) this.titleEl.innerHTML = fill(data.title);
      if (this.subEl) this.subEl.innerHTML = fill(data.sub);
    }
  }

  customElements.define('series-pill', SeriesPill);
})();
